export const generateMockUser = ({ authBroker }) => ({
  data: {
    id: '',
    type: 'users_scaffolds',
    attributes: {
      services: [
        'facilities',
        'hca',
        'edu-benefits',
        'form-save-in-progress',
        'form-prefill',
        'evss-claims',
        'form526',
        'user-profile',
        'appeals-status',
        'id-card',
        'identity-proofed',
        'vet360',
      ],
      account: {
        accountUuid: '7d9e2bfb-13ae-45c8-8764-ea3c87cd8af3',
      },
      profile: {
        email: 'vets.gov.user+75@gmail.com',
        firstName: 'MITCHELL',
        middleName: 'G',
        lastName: 'JENKINS',
        birthDate: '1949-03-04',
        gender: 'M',
        zip: '97063',
        lastSignedIn: '2022-03-24T18:15:06.566Z',
        loa: {
          current: 3,
          highest: 3,
        },
        multifactor: true,
        verified: true,
        signIn: {
          authBroker: 'sis',
          serviceName: 'idme',
          accountType: 'N/A',
        },
        authnContext: 'http://idmanagement.gov/ns/assurance/loa/3',
      },
      vaProfile: {
        status: 'OK',
        birthDate: '19490304',
        familyName: 'Jenkins',
        gender: 'M',
        givenNames: ['Mitchell', 'G'],
        isCernerPatient: false,
        facilities: [
          {
            facilityId: '989',
            isCerner: false,
          },
          {
            facilityId: '987',
            isCerner: false,
          },
          {
            facilityId: '983',
            isCerner: false,
          },
        ],
        vaPatient: false,
        mhvAccountState: 'NONE',
      },
      veteranStatus: {
        status: 'OK',
        isVeteran: true,
        servedInMilitary: true,
      },
      inProgressForms: [],
      prefillsAvailable: ['21-686C'],
      vet360ContactInformation: {
        email: {
          createdAt: '2018-04-20T17:24:13.000Z',
          emailAddress: 'myemail72585885@unattended.com',
          effectiveEndDate: null,
          effectiveStartDate: '2019-03-07T22:32:40.000Z',
          id: 20648,
          sourceDate: '2019-03-07T22:32:40.000Z',
          sourceSystemUser: null,
          transactionId: '44a0858b-3dd1-4de2-903d-38b147981a9c',
          updatedAt: '2019-03-08T05:09:58.000Z',
          vet360Id: '1273766',
        },
        residentialAddress: {
          addressLine1: '345 Home Address St.',
          addressLine2: null,
          addressLine3: null,
          addressPou: 'RESIDENCE/CHOICE',
          addressType: 'DOMESTIC',
          city: 'San Francisco',
          countryName: 'United States',
          countryCodeIso2: 'US',
          countryCodeIso3: 'USA',
          countryCodeFips: null,
          countyCode: null,
          countyName: null,
          createdAt: '2022-03-21T21:26:35.000Z',
          effectiveEndDate: null,
          effectiveStartDate: '2022-03-23T19:11:51.000Z',
          geocodeDate: '2022-03-23T19:11:51.000Z',
          geocodePrecision: null,
          id: 312003,
          internationalPostalCode: null,
          latitude: 37.781,
          longitude: -122.4605,
          province: null,
          sourceDate: '2022-03-23T19:11:51.000Z',
          sourceSystemUser: null,
          stateCode: 'CA',
          transactionId: 'c5adb989-3b87-47b6-afe3-dc18800cedc3',
          updatedAt: '2022-03-23T19:11:52.000Z',
          validationKey: null,
          vet360Id: '1273766',
          zipCode: '94118',
          zipCodeSuffix: null,
          badAddress: null,
        },
        mailingAddress: {
          addressLine1: '123 Mailing Address St.',
          addressLine2: 'Apt 1',
          addressLine3: null,
          addressPou: 'CORRESPONDENCE',
          addressType: 'DOMESTIC',
          city: 'Fulton',
          countryName: 'United States',
          countryCodeIso2: 'US',
          countryCodeIso3: 'USA',
          countryCodeFips: null,
          countyCode: null,
          countyName: null,
          createdAt: '2022-03-21T21:06:15.000Z',
          effectiveEndDate: null,
          effectiveStartDate: '2022-03-23T19:14:59.000Z',
          geocodeDate: '2022-03-23T19:15:00.000Z',
          geocodePrecision: null,
          id: 311999,
          internationalPostalCode: null,
          latitude: 45.2248,
          longitude: -121.3595,
          province: null,
          sourceDate: '2022-03-23T19:14:59.000Z',
          sourceSystemUser: null,
          stateCode: 'NY',
          transactionId: '3ea3ecf8-3ddf-46d9-8a4b-b5554385b3fb',
          updatedAt: '2022-03-23T19:15:01.000Z',
          validationKey: null,
          vet360Id: '1273766',
          zipCode: '97063',
          zipCodeSuffix: null,
          badAddress: null,
        },
        mobilePhone: {
          areaCode: '619',
          countryCode: '1',
          createdAt: '2022-01-12T16:22:03.000Z',
          extension: null,
          effectiveEndDate: null,
          effectiveStartDate: '2022-02-17T20:15:44.000Z',
          id: 269804,
          isInternational: false,
          isTextable: null,
          isTextPermitted: null,
          isTty: null,
          isVoicemailable: null,
          phoneNumber: '5551234',
          phoneType: 'MOBILE',
          sourceDate: '2022-02-17T20:15:44.000Z',
          sourceSystemUser: null,
          transactionId: 'fdb13953-f670-4bd3-a3bb-8881eb9165dd',
          updatedAt: '2022-02-17T20:15:45.000Z',
          vet360Id: '1273766',
        },
        homePhone: {
          areaCode: '989',
          countryCode: '1',
          createdAt: '2018-04-20T17:22:56.000Z',
          extension: null,
          effectiveEndDate: null,
          effectiveStartDate: '2022-03-11T16:31:55.000Z',
          id: 2272982,
          isInternational: false,
          isTextable: null,
          isTextPermitted: null,
          isTty: null,
          isVoicemailable: null,
          phoneNumber: '8981233',
          phoneType: 'HOME',
          sourceDate: '2022-03-11T16:31:55.000Z',
          sourceSystemUser: null,
          transactionId: '2814cdf6-7f2c-431b-95f3-d37f3837215d',
          updatedAt: '2022-03-11T16:31:56.000Z',
          vet360Id: '1273766',
        },
        workPhone: null,
        temporaryPhone: null,
        faxNumber: null,
        textPermission: null,
      },
      session: {
        authBroker,
        ssoe: authBroker === 'iam',
        transactionid: 'YEI6t8W3ANsvCT04oB+iXh/UP03PXSFg3Y36L2QaxLE=',
      },
    },
  },
  meta: {
    errors: null,
  },
});
